import { ChevronLeft, ChevronRight } from "lucide-react";

import { Button } from "@/ui";

interface Props {
  page: number;                 // 0-based
  hasNext: boolean;
  onPageChange: (next: number) => void;
}

export function PaginationBar({ page, hasNext, onPageChange }: Props) {
  if (page === 0 && !hasNext) return null;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        padding: "16px",
      }}
    >
      <Button
        variant="ghost"
        disabled={page === 0}
        onClick={() => onPageChange(page - 1)}
      >
        <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
          <ChevronLeft size={16} /> Назад
        </span>
      </Button>
      <span className="caption" style={{ color: "var(--fg3)" }}>
        Стр. {page + 1}
      </span>
      <Button
        variant="ghost"
        disabled={!hasNext}
        onClick={() => onPageChange(page + 1)}
      >
        <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
          Дальше <ChevronRight size={16} />
        </span>
      </Button>
    </div>
  );
}
